import Lenis from 'lenis'

import { gsap } from 'gsap'
import { Draggable } from 'gsap/Draggable'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger, Draggable)

class Scroller {
  constructor () {
    const lenis = new Lenis()
    window.lenis = lenis

    /* scrollTrigger */
    lenis.on('scroll', ScrollTrigger.update)
    gsap.ticker.add(time => {
      lenis.raf(time * 1000)
    })
    gsap.ticker.lagSmoothing(0)
  }
}

export default Scroller
